var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9603BF08-52EB-4D4B-BBAD-0EF744F928C4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-PLP",
    transform: "translate(-176.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 0,
    y: 160,
    width: 1920,
    height: 3408
  }), /*#__PURE__*/React.createElement("g", {
    id: "Filters",
    transform: "translate(176.000000, 416.000000)",
    fill: "#808080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus",
    transform: "translate(0.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8750001,1.40625001 C12.8147471,1.40625001 13.5783419,2.16044734 13.5935198,3.09657734 L13.5929445,3.90625001 L16.8746945,3.90625002 C17.133578,3.90625002 17.3434446,4.13010657 17.3434446,4.40625002 C17.3434446,4.67611308 17.1430092,4.89604346 16.8922681,4.90590098 L16.8746947,4.90625002 L16.0929445,4.90625001 L16.0937501,16.2500001 C16.0937501,16.8458985 15.6172069,17.3304944 15.0244255,17.3434827 L5.00000003,17.3437501 C4.40410157,17.3437501 3.91950573,16.8672069 3.90651737,16.2744255 L3.90594454,4.90625001 L3.12469468,4.90625002 C2.8658112,4.90625002 2.65594454,4.68239347 2.65594454,4.40625002 C2.65594454,4.13638696 2.85637995,3.91645658 3.10712111,3.90659906 L6.40594454,3.90625001 L6.40625003,3.12500002 C6.40625003,2.18525299 7.16044736,1.42165819 8.09657737,1.40648027 L11.8750001,1.40625001 Z M15.1559445,4.90625001 L4.84294454,4.90625001 L4.84375002,16.2500001 C4.84375002,16.3323721 4.90749048,16.3998567 4.9883389,16.4058215 L5.00000003,16.40625 L15.0000001,16.40625 C15.0823721,16.40625 15.1498567,16.3425096 15.1558215,16.2616612 L15.1562501,16.2500001 L15.1559445,4.90625001 Z M8.15625004,7.65625004 C8.42611645,7.65625004 8.64604769,7.85668558 8.65590517,8.10742674 L8.65625004,8.12500004 L8.65625004,13.1250001 C8.65625004,13.3838835 8.43239241,13.5937501 8.15625004,13.5937501 C7.88638363,13.5937501 7.66645239,13.3933145 7.65659491,13.1425734 L7.65625004,8.12500004 C7.65625004,7.86611656 7.88010766,7.65625004 8.15625004,7.65625004 Z M11.9062501,7.65625004 C12.1761165,7.65625004 12.3960477,7.85668558 12.4059052,8.10742674 L12.4062501,8.12500004 L12.4062501,13.1250001 C12.4062501,13.3838835 12.1823924,13.5937501 11.9062501,13.5937501 C11.6363836,13.5937501 11.4164524,13.3933145 11.4065949,13.1425734 L11.4062501,8.12500004 C11.4062501,7.86611656 11.6301077,7.65625004 11.9062501,7.65625004 Z M11.8968676,2.34405015 L8.12500004,2.34375001 C7.70084067,2.34375001 7.35563037,2.68177117 7.34405018,3.10313245 L7.34375004,3.12500002 L7.34294454,3.90625001 L12.6559445,3.90625001 L12.6562501,3.12500002 C12.6562501,2.70084065 12.3182289,2.35563035 11.8968676,2.34405015 Z",
    id: "Combined-Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1a75481c.svg";
export { ForwardRef as ReactComponent };